import { AutoComplete, Input } from 'antd';
import { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { notifyError } from '../store/utils';
import { API } from '../api';
import { UserContext } from '../context/UserProvider';

interface CustomerInputProps {
  value?: string;
  disabled?: boolean;
  onSelect?: (value: string) => void;
  onChange?: (value: string) => void;
}

const CustomerInput: React.FC<CustomerInputProps> = ({ value, disabled, onSelect, onChange }) => {
  const { getCustomer } = useContext(UserContext);
  const [state, updateState] = useState<any[]>([]);
  const [query, setQuery] = useState('');
  const [selected, setSelected] = useState(value || '');

  const loadFirst = useCallback(async () => {
    try {
      const { result } = await API.get({ apiVersion: 'api' })(
        `/customer/list?page=1&size=10&query=${query}`
      );
      const list = result?.data || [];
      updateState(list);
      if (getCustomer) {
        const item = list.find((it: any) => it.no == getCustomer.no);
        if (item) {
          if (onSelect) onSelect(item);
          setSelected(item.name);
        }
      }
    } catch (error: any) {
      notifyError(error.message);
    }
  }, [query, getCustomer]);

  const onSearch = useCallback(async (query: string) => {
    setQuery(query);
    setSelected(query);
  }, []);

  const onSelectItem = useCallback(
    async (value: string) => {
      const item = state.find((it: any) => it.no == value) || { no: null, name: value };
      if (onSelect) onSelect(item);
      setSelected(item.name);
    },
    [state]
  );

  const options = useMemo(() => {
    return state.length
      ? state.map((item: any) => {
          return {
            label: `${item.name} (${item.cd}) ${item.phone1}`,
            value: item.no,
          };
        })
      : [
          {
            label: `${query} - шинэ илгээгч оруулах`,
            value: query,
          },
        ];
  }, [state, query]);

  useEffect(() => {
    if (value) {
      setSelected(value);
    }
  }, [value]);

  useEffect(() => {
    loadFirst();
  }, [query]);

  return (
    <AutoComplete
      popupMatchSelectWidth={252}
      style={{ width: '100%' }}
      options={options}
      disabled={!!getCustomer}
      onSelect={onSelectItem}
      onSearch={onSearch}
      value={selected}
      onChange={onChange}
    >
      <Input.Search placeholder="Харилцагч нэр, утас, код..." enterButton />
    </AutoComplete>
  );
};

export default CustomerInput;
